(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var dismissButton = event.target.closest('[data-announcement-dismiss]');
    if (!dismissButton) return;
    var bar = dismissButton.closest('.announcement-bar');
    if (bar) bar.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var submitButton = event.target.querySelector('[data-contact-submit]');
    if (!submitButton) return;
    submitButton.classList.add('btn--loading');
    submitButton.disabled = true;
  });

  var successMessage = document.querySelector('[data-contact-success]');
  if (successMessage) successMessage.focus();

  } catch(e) { console.error(e); }
})();
})();
